module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/a0128-msyokusyu/msyokusyu.component.css
// module id = ./src/app/a0128-msyokusyu/msyokusyu.component.css
// module chunks = main